import { Container, Grid, Paper } from '@material-ui/core'
import React from 'react'
import { components, useTranslation } from 'cng-web-lib'

import AccessLevelUserViewForm from './AccessLevelUserViewForm'
import AccessLevelUserRuleCrudTable from './AccessLevelUserRuleCrudTable'
import { useParams } from 'react-router-dom'
import Namespace from 'src/constants/locale/Namespace'
import AccessLevelUserKeys from 'src/constants/locale/key/AccessLevelUser'

const { CngTabs } = components


function ViewPage({ showNotification }) {
	const { id } = useParams()
  const { translate } = useTranslation([Namespace.ACCESS_LEVEL_USER])
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let accessLevelUser = translate(
      Namespace.ACCESS_LEVEL_USER,
      AccessLevelUserKeys.TITLE
    )
    let accessLevelUserRule = translate(
      Namespace.ACCESS_LEVEL_USER,
      AccessLevelUserKeys.AccessLevelUserRule.TITLE
    )

    return {
      accessLevelUser,
      accessLevelUserRule
    }
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper>
          <Container maxWidth='xl'>
            <AccessLevelUserViewForm
							showNotification={showNotification}
							id={id}
							onFetchPreSuccess={() => { console.log("AccessLevelUser fetch success..") }}
						/>
          </Container>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <CngTabs
          headerColor='primary'
          tabs={[
            {
              tabName: translatedTextsObject.accessLevelUser,
              tabContent: (
                <AccessLevelUserViewForm
                  showNotification={showNotification}
                  id={id}
                />
              )
            },
            {
              tabName: translatedTextsObject.accessLevelUserRule,
              tabContent: (
                <AccessLevelUserRuleCrudTable
                  showNotification={showNotification}
                  accessLevelUserId={id}
                  isViewOnly={true}
                />
              )
            },
          ]}
        />
      </Grid>
    </Grid>
  );
}

export default ViewPage